<template>
  <div class="k_main">
    <searchC></searchC>
    <div class="content">
      <div class="topadcs">
        <img :src="kimg.tp" v-if="kimg.tp" title="世界知名焊接设备首选供应商" alt="世界知名焊接设备首选供应商" />
      </div>
      <div class="left2">
        <div class="left2top"></div>
        <div class="left2_main">
          <div class="n_info_con" id="printableview">
            <h1>{{list.title}}</h1>
            <div class="info_con_tit">
              <div class="info_con_tit">
                <div class="n_tit">
                  <span>发布时间：{{list.create_time}}</span>
                  <!---->
                  <span>
                    人气：
                    <span id="cntrHits">{{list.hit}}</span>
                  </span>
                </div>
              </div>
            </div>
            <div v-html="list.nr">
              <br />
              <br />
            </div>
            <div class="clear"></div>

          </div>

          <div class="n_info_con2">
            <h4 class="t04">相关资讯</h4>
            <div class="info_b">
              <ul class="p_list_ul">
                <li v-for="item in news" :key="item.id">
                  <router-link tag="a" target="_blank" :to="{ name: 'news', params: { id: item.id}}">{{item.title}}</router-link>
                </li>
              </ul>
              <div class="clear"></div>
            </div>
            <div class="clear"></div>
          </div>
        </div>
        <div class="left2bot"></div>
      </div>
      <div class="right2">
        <div class="right2top"></div>
        <div class="right2_main">
          <h4 class="t03">
            <a href="http://www.qiongj.com/gsxw.html" title="同类文章排行">同类文章排行</a>
          </h4>
          <ul class="n_rt_ul">
            <li v-for="item in plist" :key="item.id">
              <router-link tag="a" target="_blank" :to="{ name: 'news', params: { id: item.id}}">{{item.title}}</router-link>
            </li>
          </ul>
          <h4 class="t03">
            <a href="http://www.qiongj.com/news/" title="最新资讯文章">最新资讯文章</a>
          </h4>
          <ul class="n_rt_ul" id="cntrLastArticle">
           <li v-for="item in plist" :key="item.id">
              <router-link tag="a" target="_blank" :to="{ name: 'news', params: { id: item.id}}">{{item.title}}</router-link>
            </li>
          </ul>
        </div>
        <div class="right2bot"></div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import { getNews } from "@/utils/api"; //引入api至当前文件
import searchC from "@/views/search";
export default {
  name: "news",
  data() {
    return {
      kimg: "",
      list: [],
      plist: [],
      news: []
    };
  },
  components: {
    searchC
  },
  mounted() {
    this.intPage();
  },
  watch: {
    $route() {
      this.intPage();
    }
  },
  methods: {
    intPage() {
      let id = this.$route.params.id ? this.$route.params.id : 1;
      getNews(id).then(res => {
        this.kimg = res.imgs;
        this.list = res.list;
        this.plist = res.plist;
        this.news = res.news;
      });
    }
  }
};
</script>

<style scoped>
</style>
